'use client';
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';
import { t } from 'i18next';

// Generic dropdown
import { SelectDropdown, type SelectOption } from './select-dropdown.tsx';

export type TypologyOption = {
  name: string;
};

interface TypologyDropdownProps {
  options?: TypologyOption[];
  loading: boolean;
  onChange?: (typology: TypologyOption | null) => void;
  defaultValue?: string;
  disabled?: boolean;
  placeholder?: string;
  slim?: boolean;
}

const TypologyDropdownComponent = (
  {
    options = [],
    onChange,
    defaultValue,
    loading = false,
    disabled = false,
    placeholder = 'Select a typology',
    slim = false,
    ...props
  }: TypologyDropdownProps,
  ref: ForwardedRef<HTMLButtonElement>
) => {
  // Convert TypologyOption to SelectOption
  const selectOptions: SelectOption<TypologyOption>[] = options.map((typology) => ({
    value: typology.name,
    label: typology.name,
    data: typology
  }));

  return (
    <SelectDropdown<TypologyOption>
      ref={ref}
      options={selectOptions}
      loading={loading}
      disabled={disabled}
      placeholder={placeholder}
      slim={slim}
      searchPlaceholder={t('common.label.search.by', { field: t('label.company.typology') })}
      allowDeselect={true}
      onChange={(option) => {
        onChange?.(option?.data || null);
      }}
      defaultValue={defaultValue}
      {...props}
    />
  );
};

TypologyDropdownComponent.displayName = 'TypologyDropdownComponent';

export const TypologyDropdown = forwardRef(TypologyDropdownComponent);
